<template>
  <div class="page-box decision-box">
    <div class="decision-head">
      <div class="decision-head-left">运行风险源管理及支持系统</div>
      <div class="decision-head-right">
        <div class="decision-head-bt" @click="historyErroyRecord"><img src="@/assets/images/yi.png"/>历史记录</div>
        <div class="decision-head-bt active" @click="$router.push('/index')"><img src="@/assets/images/yi2.png"/>回到首页
        </div>
      </div>
    </div>
    <div class="decision-page">
      <div class="homepage-top" v-if="!errorRecordList.length">
            <div class="manage-top">
              <div class="manage-left">
                <img src="@/assets/images/icon3.png"/>
              </div>
              <div class="manage-right">
                <div class="manage-h">地面运行起飞前故障决策</div>
                <div class="manage-p">飞行员完成故障信息的输入，启动系统识别飞机风险源</div>
              </div>
            </div>
            <div class="manage-bottom task-b">
              <img src="@/assets/images/qq4.png"/>
              <div class="p">暂无故障</div>
            </div>
      </div>
      <!--故障列表-->
      <div class="task-box" v-if="errorRecordList.length">
        <div class="task-top">
          <div class="manage-top">
              <div class="manage-left">
                <img src="@/assets/images/icon3.png"/>
              </div>
              <div class="manage-right">
                <div class="manage-h">地面运行起飞前故障决策</div>
                <div class="manage-p">飞行员完成故障信息的输入，启动系统识别飞机风险源</div>
              </div>
          </div>
        </div>
        <div class="task-ul" @scroll="load($event)">
          <div class="task-li" v-for="(item,index) in errorRecordList">
            <div class="task-text">
              <div class="task-h">{{item.fullFaultMessage}}    {{item.lastResultComment}}</div>
              <div class="task-p">
                <div class="task-laber">{{item.flightNo}}&nbsp;&nbsp;</div>
                <div class="task-laber">{{item.planeType}}&nbsp;&nbsp;</div>
                <div class="task-laber">{{item.planeId}}（注册号）/&nbsp;&nbsp;{{item.msn}}（MSN编号)</div>
              </div>
            </div>
            <div class="task-bt" @click="goMalfunction(item)">进入查看</div>
          </div>
        </div>
      </div>
      <!--历史记录-->
      <history v-if="isHistory" :dialogVisible="isHistory" :client="client" @handle-close="closeHistory"></history>
    </div>
  </div>
</template>

<script>
import History from "../../components/History";
import {planeErrorRecordHistory } from '@/api/api'
  export default {
    name: "decision",
    components: {History},
    data() {
      return{
        query:{
          number: 1,
          limit: 10,
        },
        params:{
          done: false,
          orderBy:JSON.stringify([{"name":"id","direction":"DESC"}])
        },
        errorRecordList: [],
        isScroll: true,
        isHistory: false,
        client: null,
        isHistoryNum: true,
        options: [],
        value: undefined
      }
    },
    //todo 列表历史记录  列表数据分割
    created() {
      this.isHistory=this.$route.params.history
      this.client=this.$route.params.client
    },
    mounted() {
      this.getPlaneErrorRecord()
    },
    methods:{
      async getPlaneErrorRecord() {
        this.isScroll = false
        const res = await planeErrorRecordHistory(this.query,this.params)
        if(res.code === 'A00000' && res.data.length) {
          this.errorRecordList = [...this.errorRecordList, ...res.data]
          this.isScroll = true
          if(res.data.length < 10){
            this.isScroll = false
          //  this.$message.info('已全部加载完')
          }
        }else {
          this.isScroll = false
        }
      },
      load(e){
        const sHeight = e.target.scrollHeight
        const sTop = e.target.scrollTop
        const cHeight = e.target.clientHeight
        if(sTop + cHeight + 50 >=  sHeight && this.isScroll) {
          this.morePage()
        }
      },
      morePage() {
        this.query.number++
       /* if(this.isHistory){
          this.historyErroyRecord()
        } else{
          this.getPlaneErrorRecord()
        }*/
        this.getPlaneErrorRecord()
      },
     async historyErroyRecord() {
        this.isHistory=true
       //this.$router.push(`/task/${this.client}/true`)
      },
      goMalfunction(item) {
        if ('ROLE_MECH'===this.client){
          this.$router.push(`/malfunctionMech/${item.id}`)
        }else if ('ROLE_SOC'===this.client){
          this.$router.push(`/malfunction/${item.id}`)
        }
      },
      closeHistory(){
        this.isHistory=false
      }
    }
  }
</script>

<style lang="less" scoped>
.decision-page .el-dialog__wrapper{
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/task/task.vue